import React from 'react'

const Steps = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className="container">
      <div className="row">
        <div className="col-lg-6 items">
          <ul>
            {block.items.map((item, index) => {
              return <li key={index}>
                <div className="step-wr">
                  {item.title && ( <h4 dangerouslySetInnerHTML={{__html: item.title}}></h4> )}
                  {item.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: item.text}}></div> )}
                </div>
              </li>
            })}
          </ul>
        </div>
        <div className="col-5 offset-1 is-desktop">
          {block.image && (
            <img src={block.image} alt={block.image_alt_text} title={block.image_alt_text} />
          )}
        </div>
      </div>
    </div>
  </section>
)

export default Steps
